<template>
    <verification-upload @uploaded="onUploaded" />
</template>

<script>
import VerificationUpload from "@/components/verification/VerificationUpload";

export default {
    methods: {
        onUploaded(url) {
            this.api
                .post("/userVideo/uploadVerification", {
                    url,
                    code: this.code,
                })
                .then(() => {
                    this.$store.dispatch("onboarding/status");
                });
        },
    },
    components: {
        VerificationUpload,
    },
    props: ["code"],
};
</script>
